<template>
    <div class="shopact">
        <div class="music-play">
            <MusicPlay />
        </div>
        <img v-for="(itm, rowidx) in imgs" :key="rowidx" :src="itm.img" />
        <van-panel desc="" status="">
            <van-cell slot="header">
                <div class="label-title shop-title">{{ data.shop_name }}</div>
            </van-cell>
            <van-cell-group>
                <van-cell>
                    <template slot="title">
                        <span class="label-title">地址:</span>
                        <span class="label-content">{{ data.shop_address }}</span>
                    </template>
                </van-cell>
                <van-cell>
                    <template slot="title">
                        <span class="label-title">电话:</span>
                        <span class="custom-title">{{ data.shop_phone }}</span>
                    </template>
                </van-cell>
                <van-cell>
                    <template slot="title">
                        <span class="label-title">活动时间:</span>
                        <span class="custom-title">{{ data.begin_date }}至{{ data.end_date }}</span>
                    </template>
                </van-cell>
                <van-cell>
                    <template slot="title">
                        <span class="label-title">抢购价格:</span>
                        <span class="custom-title">{{ data.amount }}</span>
                    </template>
                </van-cell>
            </van-cell-group>
        </van-panel>
        <van-goods-action>
            <div class="spc" />
            <a :href="'tel:' + data.shop_phone">
                <van-goods-action-icon icon="phone-o" text="拨打电话"/>
            </a>
            <div class="spc" />
            <van-goods-action-icon icon="chat-o" text="分享好友" @click="onShare" />
            <van-goods-action-button type="danger" text="立即抢购" @click="onBuy" />
            <div class="spc" />
        </van-goods-action>
        <ToShare ref="toshare" />
    </div>
</template>

<script>
import { 
    NavBar,
    Panel, 
    Dialog,
    CellGroup,
    Cell,
    Card, 
    Image,
    Toast,
    Loading, 
    GoodsAction,
    GoodsActionIcon,
    GoodsActionButton
} from 'vant'

import { ShopActApi, ShopActImgApi } from '@/api/shopact'
import { WxShopActMusicUrl } from '@/api/assert'
import MusicPlay from '@/view/components/musicplay'
import ToShare from '@/view/components/toshare'
import wxshare from '@/utils/wxshare'
import { getOpenId } from '@/utils/auth'

// eslint-disable-next-line no-unused-vars
// import vConsole from '@/utils/vconsole'

export default {
    components: {
        [NavBar.name]: NavBar,
        [Panel.name]: Panel,
        [Dialog.name]: Dialog,
        [Card.name]: Card,
        [CellGroup.name]: CellGroup,
        [Cell.name]: Cell,
        [Toast.name]: Toast,
        [Loading.name]: Loading,
        [Image.name]: Image,
        [GoodsAction.name]:GoodsAction,
        [GoodsActionIcon.name]:GoodsActionIcon,
        [GoodsActionButton.name]:GoodsActionButton,
        MusicPlay,
        ToShare
    },
    data() {
        return {
            data: {
                id: 0,
                shop_name: '',
                shop_address: '',
                shop_phone: '',
                shop_img: '',
                title: null,
                package_name: '',
                create_date: '',
                begin_date: '',
                end_date: null,
                rem: null,
                note: null,
                amount: null,
                style_name: null,
                state_name: null,
                check_date: null,
                checker: null,
                checker_name: null,
                publish_date: null,
                publisher: null,
                publisher_name: null,
                package_data: {
                id: null,
                name: null,
                price: null,
                servers: [],
                versions: []
                }
            },
            imgs: [],
            loading: false,
            music: WxShopActMusicUrl
        }
    },
    mounted() {
        console.log('进来的路由')
        console.log(this.$route)
        console.log(this.$route.params)
        this.data.id = this.$route.params.id,
        console.log(this.data.id)
        console.log(this.$route.query)
        console.log(this.$route.query.shared_id)
        this.getData(this.data.id)
        this.getActImgs(this.data.id)
        console.log('show debug')
        
    },
    methods: {
        getActImgs(id) {
            var that = this
            that.axios.get(ShopActImgApi + '?shop_activity_id=' + id).then((ret) => {
                console.log('images')
                console.log(ret)
                that.imgs = ret.results
            })
        },
        getData(id) {
            var that = this
            that.loading = true
            that.axios.get(ShopActApi + id + '/').then((ret) => {
                console.log(ret)
                if (ret.flag) {
                    that.loading = false
                    that.data = ret.details
                    console.log('openid')
                    const openid = getOpenId()
                    console.log(openid)
                    console.log('分享信息')
                    console.log(ret)
                    wxshare.shareItem(`您的好友正在分享${that.data.title}`, 
                        that.data.rem, 
                        that.data.shop_img, 
                        `${window.location.origin}/#/nt/activities/shopact/${this.data.id}/?shared_id=` + openid )
                } else {
                    console.log(ret.info)
                    this.$router.push({
                        path: '/nt/errorpage',
                        query: {
                            title: '',
                            info: ret.info 
                        }
                    })
                }
            })
        },
        onShare() {
            this.$refs.toshare.show()
        },
        onBuy() {
            // wxshare.getJSSDK()
            console.log(`nt/activities/shopactbuy/${this.data.id}/`)
            this.$router.push(`/nt/activities/shopactbuy/${this.data.id}/?shared_id=${this.$route.query.shared_id}`)
        }
    }
}
</script>

<style lang="less">
.van-button--danger {
    margin-left: 60px;
}
</style>

<style lang="less" scoped>
.shopact {
    img {
        width: 100%;
        border: 0;
        margin: 0;
        padding: 0;
        vertical-align:bottom;
        vertical-align:top;
    }
    .label-title {
        font-weight: bold;
        margin-right: 8px;
    }
    .shop-title {
        text-align: center;
    }
    .music-play {
        // margin-right: 5em;
        // font-size: 60px;
        z-index:999;
    }
    .spc {
        width: 1em;
    }
}
</style>